import React from 'react';
import {
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  Award,
  BadgeCheck,
  BedDouble,
  Bell,
  BookOpen,
  Bookmark,
  Building2,
  Bus,
  Calendar,
  CalendarDays,
  Camera,
  Car,
  Cat,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CirclePlay,
  CircleX,
  Clock,
  Code,
  Compass,
  Contact,
  Database,
  Download,
  Edit,
  ExternalLink,
  Eye,
  FileText,
  Filter,
  Flame,
  Gift,
  Globe,
  Handshake,
  Headset,
  Heart,
  HeartHandshake,
  Home,
  Hotel,
  Image,
  IndianRupee,
  Info,
  Landmark,
  Languages,
  LayoutDashboard,
  LayoutGrid,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  MapPinned,
  Menu,
  MessageCircle,
  Minus,
  Moon,
  Music,
  Navigation,
  Newspaper,
  Package,
  PanelsTopLeft,
  Phone,
  Plane,
  Plus,
  Quote,
  Route,
  Search,
  Send,
  Settings,
  Share2,
  ShieldCheck,
  Shirt,
  SlidersHorizontal,
  Smartphone,
  Sparkle,
  Sparkles,
  Star,
  Stars,
  Store,
  Sun,
  Sunrise,
  Sunset,
  Ticket,
  TrainFront,
  Trash,
  Trash2,
  Tv,
  User,
  UserPlus,
  Users,
  Utensils,
  Video,
  Wallet,
  Waves,
  Wifi,
  X,
} from 'lucide-react';

const LUCIDE = {
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up-down': ArrowUpDown,
  'award': Award,
  'badge-check': BadgeCheck,
  'bed-double': BedDouble,
  'bell': Bell,
  'book-open': BookOpen,
  'bookmark': Bookmark,
  'building-2': Building2,
  'bus': Bus,
  'calendar': Calendar,
  'calendar-days': CalendarDays,
  'camera': Camera,
  'car': Car,
  'cat': Cat,
  'check': Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-play': CirclePlay,
  'circle-x': CircleX,
  'clock': Clock,
  'code': Code,
  'compass': Compass,
  'contact': Contact,
  'database': Database,
  'download': Download,
  'edit': Edit,
  'external-link': ExternalLink,
  'eye': Eye,
  'file-text': FileText,
  'filter': Filter,
  'flame': Flame,
  'gift': Gift,
  'globe': Globe,
  'handshake': Handshake,
  'headset': Headset,
  'heart': Heart,
  'heart-handshake': HeartHandshake,
  'home': Home,
  'hotel': Hotel,
  'image': Image,
  'indian-rupee': IndianRupee,
  'info': Info,
  'landmark': Landmark,
  'languages': Languages,
  'layout-dashboard': LayoutDashboard,
  'layout-grid': LayoutGrid,
  'list': List,
  'lock': Lock,
  'log-in': LogIn,
  'log-out': LogOut,
  'mail': Mail,
  'map': Map,
  'map-pin': MapPin,
  'map-pinned': MapPinned,
  'menu': Menu,
  'message-circle': MessageCircle,
  'minus': Minus,
  'moon': Moon,
  'music': Music,
  'navigation': Navigation,
  'newspaper': Newspaper,
  'package': Package,
  'panels-top-left': PanelsTopLeft,
  'phone': Phone,
  'plane': Plane,
  'plus': Plus,
  'quote': Quote,
  'route': Route,
  'search': Search,
  'send': Send,
  'settings': Settings,
  'share-2': Share2,
  'shield-check': ShieldCheck,
  'shirt': Shirt,
  'sliders-horizontal': SlidersHorizontal,
  'smartphone': Smartphone,
  'sparkle': Sparkle,
  'sparkles': Sparkles,
  'star': Star,
  'stars': Stars,
  'store': Store,
  'sun': Sun,
  'sunrise': Sunrise,
  'sunset': Sunset,
  'ticket': Ticket,
  'train-front': TrainFront,
  'trash': Trash,
  'trash-2': Trash2,
  'tv': Tv,
  'user': User,
  'user-plus': UserPlus,
  'users': Users,
  'utensils': Utensils,
  'video': Video,
  'wallet': Wallet,
  'waves': Waves,
  'wifi': Wifi,
  'x': X,
};

/**
 * Icon — thin wrapper over lucide-react plus a few custom devotional glyphs
 * (temple, diya, namaste, om, kalash, aarti) drawn on the same 24px grid.
 *
 * Usage: <Icon name="map-pin" size={18} />  (kebab-case lucide names)
 */

const Custom = {
  temple: (p) => (
    <svg {...p}>
      <path d="M12 2l1.4 2.6L12 7l-1.4-2.4L12 2Z" />
      <path d="M5 21v-8.5L12 7l7 5.5V21" />
      <path d="M2.5 21h19" />
      <path d="M9.5 21v-5h5v5" />
      <path d="M4 12.5h16" />
      <path d="M8 16.5h.01M16 16.5h.01" />
    </svg>
  ),
  diya: (p) => (
    <svg {...p}>
      <path d="M12 3.5c1.6 1.7 1.6 3.6 0 5.3-1.6-1.7-1.6-3.6 0-5.3Z" />
      <path d="M4 13h16a8 8 0 0 1-16 0Z" />
      <path d="M12 8.8v4.2" />
      <path d="M3 20h18" />
    </svg>
  ),
  namaste: (p) => (
    <svg {...p}>
      <path d="M12 3.5C9.2 7.5 7.7 11.3 7.7 15c0 2.9 1.9 5 4.3 5.5" />
      <path d="M12 3.5c2.8 4 4.3 7.8 4.3 11.5 0 2.9-1.9 5-4.3 5.5" />
      <path d="M6 20.5h12" />
    </svg>
  ),
  om: (p) => (
    <svg {...p}>
      <path d="M5 9.5c1.6-1.9 4.4-1.9 6 0" />
      <path d="M8.5 12.5c-3 0-4.5 1.8-4.5 3.8S5.6 20 8.5 20s5-2 5-5-2-3.5-4-3.5" />
      <path d="M13.5 11.5c2.2 0 3.8 1.5 3.8 3.5s-1.6 3.5-3.8 3.5" />
      <path d="M13.5 7c1.4-1.3 3.2-1.3 4.6 0" />
      <circle cx="18.5" cy="3.5" r="1" />
    </svg>
  ),
  kalash: (p) => (
    <svg {...p}>
      <path d="M8 5.5h8" />
      <path d="M9.5 5.5v2M14.5 5.5v2" />
      <path d="M6 7.5h12l-1.4 10.2a3 3 0 0 1-3 2.6h-3.2a3 3 0 0 1-3-2.6L6 7.5Z" />
      <path d="M12 2v3.5" />
      <path d="M9 3.5c1-1 5-1 6 0" />
    </svg>
  ),
  aarti: (p) => (
    <svg {...p}>
      <path d="M12 3c1.3 1.5 1.3 3.2 0 4.7C10.7 6.2 10.7 4.5 12 3Z" />
      <path d="M6 9.5h12v1.5a6 6 0 0 1-12 0V9.5Z" />
      <path d="M12 17v4" />
      <path d="M8 21h8" />
    </svg>
  ),
};

export default function Icon({ name, size = 18, strokeWidth = 1.5, className = '', style, ...rest }) {
  const cls = `icon${className ? ` ${className}` : ''}`;
  if (Custom[name]) {
    return Custom[name]({
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      className: cls,
      style,
      'aria-hidden': true,
      ...rest,
    });
  }
  const L = LUCIDE[name];
  if (!L) {
    if (process.env.NODE_ENV !== 'production') console.warn(`[Icon] unknown icon "${name}"`);
    return <span style={{ width: size, height: size, display: 'inline-block' }} aria-hidden="true" />;
  }
  return <L size={size} strokeWidth={strokeWidth} className={cls} style={style} aria-hidden="true" {...rest} />;
}
